// extracted by mini-css-extract-plugin
export default {"customComponentContainer":"CustomFormioComponents_customComponentContainer__wYlDD","bigger":"CustomFormioComponents_bigger__Jj1op"};